import { DepartmentKey, SelectedSpecialties } from '~/store/slices/filterSlice'
import { StoreState } from '~/store/store'
import { selectDepartment, selectSpecialities } from '~/storm'

/**
 * When there is no explicit specialty selection, fall back to every specialty
 * belonging to the selected department (or `'all'` when no department is picked).
 * Requires DI entities to be loaded, so call it after hydration rather than in
 * the persist `merge` step.
 */
export function resolveSelectedSpecialties(
    state: StoreState,
    departmentKey: DepartmentKey,
    selectedSpecialties: SelectedSpecialties | null | undefined
): SelectedSpecialties {
    const hasExplicitSelection = selectedSpecialties === 'all' || (Array.isArray(selectedSpecialties) && selectedSpecialties.length > 0)
    if (hasExplicitSelection) return selectedSpecialties

    if (departmentKey === 'all') return 'all'

    const department = selectDepartment(state, { where: { id: departmentKey } })
    if (!department) return 'all'

    return selectSpecialities(state, { where: { department_uuid: department.uuid } }).map(specialty => specialty.uuid)
}
